<template>
  <el-dialog
    :visible.sync="visible"
    width="660px"
    center
    :show-close="false"
    :before-close="handleClose"
  >
    <template slot="title">
      <DialogsHeader title="对齐文件未保存" />
    </template>
    <div class="content-text">系统检测到上一次对齐内容没有保存，是否继续对齐？</div>
    <span slot="footer" class="dialog-footer">
      <el-button class="close" @click="handleClose">否</el-button>
      <el-button class="confirm" type="primary" @click="handleConfirm"
        >是</el-button
      >
    </span>
  </el-dialog>
</template>
  
  <script>
import DialogsHeader from "@/common/dialogsHeader";
export default {
  name: "unSaveDialog.vue",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: { DialogsHeader },
  data() {
    return {};
  },

  methods: {
    handleClose(){
        this.$emit('handleClose')
    },
    handleConfirm(){
        this.$emit('handleConfirm');
    }
  },
};
</script>
  
  <style lang="less" scoped>
/deep/.el-dialog {
  border-radius: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 !important;
  transform: translate(-50%, -50%);
}
  .content-text{
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #303133;
  }
</style>